import { render } from "./EventCard.vue?vue&type=template&id=b6f67358&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=b6f67358&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b6f67358"

export default script